module.exports = __webpack_public_path__ + "public/files/img/paper-plane.765530b5.png";